/**
 * @author Mevan Nirosh
 * @version 1.0
 * @since 06/26/2023
 */
import axiosAuthApiInstance from "./AuthApi"
import AuthInstance from "./Auth"
import StorageService from "./StorageService"
import AuthService from "./AuthService"

const AuthApiInterceptors = () => {
  console.log("Interceptors called")
  // Add a request interceptor
  axiosAuthApiInstance.interceptors.request.use(
    (config) => {
      const token = StorageService.getAccessToken()
      console.log("request made")
      if (token) {
        config.headers["Authorization"] = "bearer " + token
        config.headers["Accept-Version"] = "2.0"
      }
      return config
    },
    (error) => {
      Promise.reject(error)
    }
  )

  axiosAuthApiInstance.interceptors.response.use(
    (response) => {
      return response
    },
    async (error) => {
      console.log("refresh route working")
      const originalRequest = error.config

      if (error.response.status === 401 && !originalRequest._retry) {
        console.log("Access token expired")
        originalRequest._retry = true
        const refreshToken = StorageService.getRefreshToken()
        AuthInstance.post(
          "/token?grant_type=refresh_token&refresh_token=" + refreshToken
        )
          .then((res) => {
            if (res.status === 200) {
              localStorage.setItem(
                "accessToken",
                JSON.stringify(res?.data.access_token)
              )
              localStorage.setItem("isLoggedin", true)

              axiosAuthApiInstance.defaults.headers.common["Authorization"] =
                "bearer " + JSON.stringify(res?.data.access_token)
              return axiosAuthApiInstance(originalRequest)
            }
          })
          .catch((error) => {
            if (
              (error.response.status === 401 &&
                error.response.data.error === "invalid_token") ||
              (error.response.status === 400 &&
                error.response.data.error === "invalid_grant")
            ) {
              AuthService.LogoutWithoutAPI()
            }
          })
      }

      const validLogoutTypes = new Set([
        "session_timeout",
        "token_not_exists",
        "account_not_activated",
        "authentication_fail",
      ])

      if (validLogoutTypes.has(error.response.data.type)) {
        AuthService.LogoutWithoutAPI()
      }

      return Promise.reject(error)
    }
  )
}
export default AuthApiInterceptors
